import Vue from "vue"

export function ifDev(f) {
  if (isDev()) f()
}
export function devLog(msg, ...args) {
  if (isDev()) console.log(`%c [DEVLOG] ${msg}`, "color:#3c98fb; font-size: 1rem;", ...args)
}
export function devWarn(msg, ...args) {
  if (isDev()) console.warn(`[DEVWARN] ${msg}`, ...args)
}
export function isDev() {
  // NOTE: according to this https://v2.vuejs.org/v2/api/#devtools
  // by default in DEV MODE Vue.config.devtools is TRUE and FALSE in PROD MODE
  // *** as long as nobody sets it to TRUE
  return Vue.config.devtools
}